import * as WebBrowser from 'expo-web-browser';
import React, { memo } from 'react';
import { Dimensions } from 'react-native';
import RenderHtml, { CustomBlockRenderer, MixedStyleDeclaration } from 'react-native-render-html';

import { Colors } from '@/constants/theme';

const { width } = Dimensions.get('window');

const mainStyle: MixedStyleDeclaration = {
  fontFamily: 'Lexend-Regular',
  fontSize: 14,
  lineHeight: 24,
  color: Colors.light.text,
};

export const defaultTagsStyles = {
  h1: {
    fontFamily: 'Lexend-Bold',
    fontSize: 24,
    color: Colors.light.text,
  },
  h2: {
    fontFamily: 'Lexend-Bold',
    fontSize: 16,
    color: Colors.light.text,
  },
  h3: {
    fontFamily: 'Lexend-Bold',
    fontSize: 14,
    color: Colors.light.text,
  },
  p: {
    fontSize: 14,
    color: Colors.light.text,
    marginBottom: 8,
    marginTop: 0,
    lineHeight: 24,
  },
  li: {
    fontSize: 14,
    color: Colors.light.text,
    marginLeft: 8,
    marginBottom: 4,
  },
  strong: {
    fontFamily: 'Lexend-Bold',
  },
};

interface props {
  data: string | undefined;
  tagsStyles?: Record<string, MixedStyleDeclaration>;
}

const ARenderer: CustomBlockRenderer = ({ TDefaultRenderer, ...props }) => {
  const onPress = () => {
    const href = props.tnode.attributes.href;
    if (href.includes('http')) {
      WebBrowser.openBrowserAsync(href, {
        dismissButtonStyle: 'done',
      });
    }
  };
  return <TDefaultRenderer {...props} onPress={onPress} />;
};

const HtmlView = ({ data, ...props }: props) => {
  if (data === undefined) {
    return null;
  }
  return (
    <RenderHtml
      systemFonts={['Lexend-Regular', 'Lexend-Bold']}
      contentWidth={width}
      baseStyle={mainStyle}
      tagsStyles={{
        ...defaultTagsStyles,
        ...props.tagsStyles,
      }}
      source={{ html: data }}
      renderers={{
        a: ARenderer,
      }}
    />
  );
};

export default memo(HtmlView);
